/* eslint-disable */
import React, { useState, useEffect } from 'react';

const FARVE = (dage) => {
  if (dage === null || dage === undefined) return '#6b7280';
  if (dage <= 7) return '#22c55e';
  if (dage <= 14) return '#f59e0b';
  if (dage <= 30) return '#ef4444';
  return '#7c3aed';
};

export default function StagnationsradarPanel() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const hent = () =>
      fetch('/api/os/sags-diagnostik/stagnation', { credentials: 'include' })
        .then(r => r.json())
        .then(setData)
        .catch(console.error)
        .finally(() => setLoading(false));
    hent();
    const interval = setInterval(hent, 120000);
    return () => clearInterval(interval);
  }, []);

  if (loading) return <div style={{ color: '#94a3b8', padding: 32 }}>Henter sagsdata...</div>;
  if (!data)   return <div style={{ color: '#ef4444', padding: 32 }}>Fejl ved hentning</div>;

  return (
    <div>
      <div style={{ display: 'flex', gap: 16, marginBottom: 24, flexWrap: 'wrap' }}>
        {[
          { label: 'Aktive sager i alt',  val: data.total,    farve: '#60a5fa' },
          { label: 'Inaktive > 14 dage',  val: data.kritiske, farve: '#ef4444' },
          { label: 'Inaktive > 30 dage',  val: (data.sager || []).filter(s => s.dage_inaktiv > 30).length, farve: '#7c3aed' },
        ].map(k => (
          <div key={k.label} style={{
            background: '#0f172a', borderRadius: 12, padding: '16px 24px',
            border: `1px solid ${k.farve}33`, minWidth: 160,
          }}>
            <div style={{ fontSize: 11, color: '#94a3b8', marginBottom: 4 }}>{k.label}</div>
            <div style={{ fontSize: 32, fontWeight: 700, color: k.farve }}>{k.val}</div>
          </div>
        ))}
      </div>

      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #1e293b' }}>
              {['Sag-ID', 'Type', 'Fase', 'Sagsbehandler', 'Klient', 'Inaktiv (dage)', 'Deadline'].map(h => (
                <th key={h} style={{ textAlign: 'left', padding: '8px 12px', color: '#64748b', fontWeight: 500 }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {(data.sager || []).slice(0, 30).map(s => (
              <tr
                key={s.id}
                style={{ borderBottom: '1px solid #0f172a', cursor: 'pointer' }}
                onClick={() => window.open(`https://app.skilsmissevejen.dk/sager/${s.id}`, '_blank')}
                onMouseEnter={e => e.currentTarget.style.background = '#1e293b'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
              >
                <td style={{ padding: '8px 12px', color: '#94a3b8' }}>{s.id}</td>
                <td style={{ padding: '8px 12px', color: '#e2e8f0' }}>{s.type || '—'}</td>
                <td style={{ padding: '8px 12px', color: '#94a3b8' }}>{s.fase || '—'}</td>
                <td style={{ padding: '8px 12px', color: '#94a3b8' }}>{s.sagsbehandler || 'Ingen'}</td>
                <td style={{ padding: '8px 12px', color: '#e2e8f0' }}>{s.fornavn} {s.efternavn}</td>
                <td style={{ padding: '8px 12px' }}>
                  <span style={{
                    background: FARVE(s.dage_inaktiv) + '22',
                    color: FARVE(s.dage_inaktiv),
                    padding: '2px 8px', borderRadius: 4, fontWeight: 600,
                  }}>
                    {s.dage_inaktiv ?? '?'} dage
                  </span>
                </td>
                <td style={{
                  padding: '8px 12px', fontSize: 12,
                  color: s.naeste_deadline && new Date(s.naeste_deadline) < new Date() ? '#ef4444' : '#94a3b8',
                }}>
                  {s.naeste_deadline ? new Date(s.naeste_deadline).toLocaleDateString('da-DK') : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
